export default "__VITE_ASSET__BxhUG_6I__"